import React from 'react'
import PropTypes from 'prop-types'
import { LiteYoutubeEmbed } from 'react-lite-yt-embed'

const YoutubePlayerLite = ({ youtubeID }) => (
  <div className='shadow-lg'>
    <LiteYoutubeEmbed id={youtubeID ? youtubeID : 'rkzG93t27UM'} />
  </div>
)

export default YoutubePlayerLite

YoutubePlayerLite.propTypes = {
  youtubeID: PropTypes.string,
}